import type React from 'react';
import { Space, Input } from 'antd';
import { ResellersSelect } from 'components/form/select/ResellersSelect';
import { Form, CustomersSelect } from 'components';
import type { CreditInvoiceFilter as CreditInvoiceFilterType } from 'lib/services';
import { FilterControlButtons } from 'components/form/FilterControlButtons';
import { DEFAULT_CREDITS_FILTER, useFilterWithPagination } from '../useFilterWithPagination';

export const CreditInvoicesFilter: React.VFC = () => {
  const [form] = Form.useForm<CreditInvoiceFilterType>();

  const { filter: filterValues, setFilterState: onChange } = useFilterWithPagination();

  const handleFormFinish = (values: CreditInvoiceFilterType) => {
    onChange({ ...values, page: 1 });
  };

  const handleReset = () => {
    form.setFieldsValue(DEFAULT_CREDITS_FILTER);
    form.submit();
  };

  return (
    <Form form={form} initialValues={filterValues} layout="inline" onFinish={handleFormFinish}>
      <Space wrap align="start" direction="horizontal">
        <Form.Item label="Search" name="search">
          <Input placeholder="Full text search" />
        </Form.Item>
        <Form.Item label="Resellers" name="resellers">
          <Form.Item labelAlign="left" labelCol={{ span: 8 }} name="resellers">
            <ResellersSelect style={{ minWidth: 200 }} />
          </Form.Item>
        </Form.Item>
        <Form.Item label="Customer" name="customers">
          <Form.Item name="customers">
            <CustomersSelect />
          </Form.Item>
        </Form.Item>
        <FilterControlButtons onClickReset={handleReset} />
      </Space>
    </Form>
  );
};
